module.exports = __webpack_public_path__ + "static/media/181.9ade4043.jpg";